<script setup lang="ts">
  import { computed } from 'vue';
  import { storeToRefs } from 'pinia';
  import userIcon from '@/shared/assets/icons/user.svg';
  import { useDashboardStore } from '../../model/dashboard.store';
  import { formatPeriodLabel } from '../../model/period';
  import HorizontalBarList, { type HorizontalBarItem } from '../HorizontalBarList.vue';
  import WidgetCard from '../WidgetCard.vue';

  const dashboardStore = useDashboardStore();
  const { data, isLoading, granularity, period } = storeToRefs(dashboardStore);

  const periodLabel = computed(() => formatPeriodLabel(granularity.value, period.value));

  const items = computed<readonly HorizontalBarItem[]>(
    () => data.value?.activeCollaboratorsByDepartment.items ?? []
  );
</script>

<template>
  <WidgetCard
    title="Colaboradores ativos"
    :icon="userIcon"
    :period-label="periodLabel"
    :loading="isLoading"
    :has-data="data !== null"
    skeleton="bar-list"
  >
    <div
      data-testid="active-collaborators-widget"
      class="-mr-3 flex h-full min-h-0 items-center"
    >
      <p
        v-if="items.length === 0"
        data-testid="active-collaborators-empty"
        class="w-full text-center text-sm text-gray-03"
      >
        Nenhum colaborador no período
      </p>
      <HorizontalBarList
        v-else
        class="max-h-full w-full pr-5"
        :items="items"
      />
    </div>
  </WidgetCard>
</template>
